// Fills the rating links in the top bar with the live shop ratings.
// Trusted Shops: same values as the floating badge (rating of the last 365
// days, number of all reviews). Trustami: values parsed from its widget API.
// Results are cached for a few hours so not every page view calls both APIs.
(() => {
  const box = document.querySelector('[data-shop-ratings]');
  if (!box || box.dataset.loaded) return;
  box.dataset.loaded = 'true';

  const TS_FEED =
    'https://integrations.etrusted.com/feeds/grades/v1/channels/chl-f36979b1-5dab-46cf-83c5-05ce286893c9/touchpoints/all/feed.json';
  const TRUSTAMI_API =
    'https://app.trustami.com/widgetapi/widgetapi-multi.php?profile=6abdfd0c738bca5b9720fd69&user=597af657efe8a6e4e6747383574941ecfe80b960&platform=0&mode=null&v=0&type=2';
  const CACHE_KEY = 'alangoShopRatings';
  const CACHE_HOURS = 6;

  const rating = (value) => value.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const count = (value) => value.toLocaleString('de-DE');

  const readCache = () => {
    try {
      const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');
      return cached.time > Date.now() - CACHE_HOURS * 3600 * 1000 ? cached : { time: Date.now() };
    } catch (error) {
      return { time: Date.now() };
    }
  };
  const cache = readCache();
  const saveCache = () => {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
    } catch (error) {}
  };

  const show = (name, value, total, label) => {
    const link = box.querySelector(`[data-rating="${name}"]`);
    if (!link || !(value > 0)) return;
    const text = link.querySelector('[data-rating-text]');
    if (!text) return;
    text.innerHTML =
      `<strong>${rating(value)}</strong> ${label}` +
      (total > 0 ? ` <span class="header-ratings__count">(${count(total)})</span>` : '');
    link.hidden = false;
    box.hidden = false;
  };

  const labels = { trustedshops: 'Trusted Shops', trustami: 'Trustami' };
  const store = (name, value, total) => {
    if (!(value > 0)) return;
    cache[name] = { value, total };
    saveCache();
    show(name, value, total, labels[name]);
  };

  if (cache.trustedshops) {
    show('trustedshops', cache.trustedshops.value, cache.trustedshops.total, labels.trustedshops);
  } else {
    fetch(TS_FEED)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const grades = data && data.grades;
        if (!grades) return;
        const year = grades['365days'] || grades.overall || {};
        const overall = grades.overall || year;
        store('trustedshops', year.rating, overall.count);
      })
      .catch(() => {});
  }

  if (cache.trustami) {
    show('trustami', cache.trustami.value, cache.trustami.total, labels.trustami);
    return;
  }

  // Trustami only offers JSONP, so the answer comes in through a callback.
  const callback = `shopRatingsTrustami${Date.now()}`;
  const script = document.createElement('script');
  window[callback] = (data) => {
    try {
      const html = Object.values(data || {})
        .filter((part) => part && Array.isArray(part.text))
        .map((part) => part.text.join(' '))
        .join(' ');
      const text = html.replace(/<style[\s\S]*?<\/style>/g, ' ').replace(/<[^>]+>/g, ' ');
      const value = text.match(/(\d[.,]\d{2})\s*\/\s*5[.,]00/);
      const total = text.match(/Trust ID\s+([\d.]+)\s/);
      store(
        'trustami',
        value ? parseFloat(value[1].replace(',', '.')) : 0,
        total ? parseInt(total[1].replace(/\./g, ''), 10) : 0
      );
    } finally {
      delete window[callback];
      script.remove();
    }
  };
  script.src = `${TRUSTAMI_API}&callback=${callback}`;
  script.async = true;
  script.onerror = () => {
    delete window[callback];
    script.remove();
  };
  document.head.appendChild(script);
})();
